import { getThemeForKey, HorizontalAlignment } from "@mcleod/core";
import { ComponentStyles } from "../../base/ComponentStyles";
import { ClickEvent } from "../../events/ClickEvent";
import { PanelProps } from "../panel/PanelProps";
import { Tab } from "./Tab";
import { TabSelectorPanel } from "./TabSelectorPanel";

export class TabSelectorPanelScroll extends TabSelectorPanel {
    private static readonly themeObject = getThemeForKey("tabset.headingScroll") ?? {};
    private static readonly themeObjectSelected = getThemeForKey("tabset.headingScrollSelected") ?? {};
    private static readonly themeObjectUnselected = getThemeForKey("tabset.headingScrollUnselected") ?? {};

    constructor(tab: Tab, props?: Partial<PanelProps>) {
        const isVerticalTabset = tab.isVertical();
        super(tab, {
            ...TabSelectorPanelScroll.themeObject,
            align: isVerticalTabset ? HorizontalAlignment.LEFT : HorizontalAlignment.CENTER,
            rowBreak: isVerticalTabset,
            ...props
        });
        this.setClassIncluded(ComponentStyles.hoverShade);
        this.addClickListener((event: ClickEvent) => {
            this.tab.selectAndScroll(event);
            this.tab.selectInDesigner();
        });
    }

    protected override get selectedThemeObject(): any {
        return TabSelectorPanelScroll.themeObjectSelected;
    }

    protected override get unselectedThemeObject(): any {
        return TabSelectorPanelScroll.themeObjectUnselected;
    }
}
